import Konva from 'konva';
import { v4 as uuidv4 } from 'uuid';

import HaspObject from './HaspObject';
import QRCode from 'qrcode'

// val	byte	0	The brightness of the indicator [0..255]

export default class HaspQrcode extends HaspObject {

    constructor(config) {
        super(config);
        this.generateQRCode();

        this.on('transform', function () {
            this.generateQRCode();
          });
      
          this.on('transformend', (e) => {
            this.generateQRCode();
            this.size(this.rect.size());
          });

          this.on('text_text', (e) => {
            this.generateQRCode();
          });
    }

    setNewSize(size) {
        super.setNewSize(size);
        this.generateQRCode();
    }

    generateQRCode() {
        QRCode.toDataURL(this.text, { width: this.rect.width(), height: this.rect.width }, (error, url) => {
            if (error) console.error(error)
            const image = new Image()
            image.src = url
            const size = this.rect.width();
            image.onload = () => {
                if (this.qrCodeRect) {
                    this.qrCodeRect.destroy()
                }
                this.qrCodeRect = new Konva.Image({
                    x: 0,
                    y: 0,
                    image: image,
                    width: size,
                    height: size,
                })
                this.add(this.qrCodeRect)
            }
        })
    }

}